import axios from 'axios';

//const API = axios.create({ baseURL: 'http://localhost:5000'});
const API = axios.create({ baseURL: 'https://emotionotes.herokuapp.com/'});

API.interceptors.request.use((req) => {
    if(localStorage.getItem('profile')){
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    }

    return req;
});

export const fetchPost = (id) => API.get(`/posts/getDetails/${id}`);
export const fetchPosts = (page) => API.get(`/posts/allPost?page=${page}`);
export const fetchPostsBySearch = (searchQuery) => API.get(`/posts/search?searchQuery=${searchQuery.search || 'none'}&tags=${searchQuery.tags}`);
export const createPost = (newPost) => API.post('/posts/post', newPost);
export const updatePost = (id, updatedPost) => API.patch(`/posts/update/${id}`, updatedPost);
export const deletePost = (id) => API.delete(`/posts/delete/${id}`);
export const likePost = (id) => API.patch(`/posts/likePost/${id}/likePost`);
export const comment = (value, id) => API.post(`/posts/comment/${id}/commentPost`, { value });

export const signIn = (formData) => API.post('/user/signin', formData);
export const signUp = (formData) => API.post('/user/signup', formData);